/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S8_P2Inputs */

const tr_iade_iptal_s8_p2 = /** @type {(inputs: Iade_Iptal_S8_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esaslı ihlal dışındaki nedenlerle Sağlayıcı'nın feshi halinde kullanılmamış döneme isabet eden bedel, ödenen bedel üzerinden kalan gün sayısının toplam dönem gün sayısına oranı esas alınarak hesaplanır ve Abone'ye iade edilir.`)
};

const en_iade_iptal_s8_p2 = /** @type {(inputs: Iade_Iptal_S8_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where the Provider terminates for reasons other than a material breach, the fee corresponding to the unused period is refunded to the Subscriber in the ratio of the remaining days to the total number of days in the period.`)
};

const de_iade_iptal_s8_p2 = /** @type {(inputs: Iade_Iptal_S8_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei einer Beendigung durch den Anbieter aus anderen Gründen als einem wesentlichen Verstoß wird das auf den nicht genutzten Zeitraum entfallende Entgelt im Verhältnis der verbleibenden Tage zur Gesamtzahl der Tage des Zeitraums an den Abonnenten erstattet.`)
};

const ru_iade_iptal_s8_p2 = /** @type {(inputs: Iade_Iptal_S8_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`При расторжении Поставщиком по причинам, отличным от существенного нарушения, сумма, приходящаяся на неиспользованный период, возвращается Абоненту в соотношении оставшихся дней к общему количеству дней периода.`)
};

/**
* | output |
* | --- |
* | "Where the Provider terminates for reasons other than a material breach, the fee corresponding to the unused period is refunded to the Subscriber in the ratio..." |
*
* @param {Iade_Iptal_S8_P2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s8_p2 = /** @type {((inputs?: Iade_Iptal_S8_P2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S8_P2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s8_p2(inputs)
	if (locale === "de") return de_iade_iptal_s8_p2(inputs)
	if (locale === "ru") return ru_iade_iptal_s8_p2(inputs)
	return tr_iade_iptal_s8_p2(inputs)
});